import './index.html';
import './style.scss';
import {imageLazyLoading} from "../../scripts/functions/imageLazyLoading";
import {animations} from "../../scripts/general/animations";
import Swiper, {Autoplay, Pagination} from 'swiper'

/**
 *
 * @param block {HTMLElement}
 * @returns {Promise<void>}
 */
const textBlock = async (block) => {
  
  const slides = block.querySelectorAll('.swiper-slide');
  
  const swiperChecker = slides.length === 1 ? {loop: false, allowTouchMove: false} : {
    loop: true, pagination: {
      el: block.querySelector('.swiper-pagination'),
      clickable: true
    },
  };
  
  let swiper = new Swiper(block.querySelector(".swiper"), {
    modules: [Autoplay, Pagination],
    slidesPerView: 1,
    ...swiperChecker,
    autoplay: {
      delay: 6000,
      pauseOnMouseEnter: false,
      stopOnLastSlide: false,
      waitForTransition: true,
    },
    
  });
  
  animations(block);
  imageLazyLoading(block);
};

export default textBlock;

